import { useQuery } from "@tanstack/react-query";
import { envConfig } from "~/lib/env-validation";
import { useAuth } from "~/lib/hooks/use-auth";

export interface ViewerProfile {
	id: string;
	email: string;
	name: string | null;
	role: "SUPER_ADMIN" | "ADMIN" | "USER";
	/** Effective entitlement (per-user flag or admin role) from /auth/me. */
	tenderExplorerEnabled: boolean;
}

/**
 * Current viewer's API profile. Anonymous visitors resolve to `undefined`
 * data (query disabled) — use `useViewer().data?.tenderExplorerEnabled` to
 * conditionally render entitlement-gated UI.
 */
export function useViewer() {
	const { session } = useAuth();

	return useQuery({
		// Keyed by user id so a same-tab account switch never serves the previous
		// account's entitlements from cache.
		queryKey: ["viewer", session?.user?.id ?? "anon"],
		queryFn: async () => {
			const res = await fetch(`${envConfig.apiBaseUrl}/auth/me`, {
				headers: { Authorization: `Bearer ${session?.access_token}` },
			});
			if (!res.ok) throw new Error("Nepodařilo se načíst profil uživatele");
			return res.json() as Promise<ViewerProfile>;
		},
		enabled: !!session?.access_token,
		staleTime: 60_000,
	});
}
